<template lang="pug">
  #section5
    #s5s1.group.container-fluid      
      img.oval.top(src="/assets/img/chapter1/oval-yellow.png")
      img.oval.mid-1(src="/assets/img/chapter1/oval-pink.png")
      img.oval.bottom(src="/assets/img/chapter1/oval-blue.png")
      #s5s1b1.row.justify-content-center.mt-5.d-flex.align-items-end
        .fake-header
        .col-11.col-sm-10.col-md-9.text-center.pause-t
          h2.py-0.uppercase.light 
            span.accent-orange-text.bolder Las etapas del virus pueden dividirse 
            span en las siguientes:
        .col-12.col-lg-4.pause-t
          p.text-center.large.accent-orange-background.bullet.bolder.neutral-text 1
          img.fit-h.img-fluid.mb-3(src="/assets/img/chapter1/stage1.png")
          p.text-center.large Un periodo asintomático de incubación del virus, con o sin virus detectable. 
        .col-12.col-lg-4.pause-t
          p.text-center.large.accent-orange-background.bullet.bolder.neutral-text 2
          img.fit-h.img-fluid.mb-3(src="/assets/img/chapter1/stage2.png")
          p.text-center.large Síntomas no severos con presencia detectable del virus
        .col-12.col-lg-4.pause-t
          p.text-center.large.accent-orange-background.bullet.bolder.neutral-text 3
          img.fit-h.img-fluid(src="/assets/img/chapter1/stage3.png")
          p.text-center.large.mt-md-5.mt-lg-3.pt-md-3.pt-lg-2 Síntomas severos respiratorios con alta carga viral. 
      #s5s1b2.row.justify-content-center.pause-t
        .col-11.col-lg-6.d-flex.align-items-center
          p.text-center.large Se calcula que 
            span.bolder el 15% de los pacientes infectados progresarán a la etapa 3.
            | Los pacientes con más de 65 años o con alguna enfermedad preexistente tienen una mayor probabilidad de llegar a la etapa severa.
        .col-12.col-lg-6
          img.fit-h.img-fluid.mb-3(src="/assets/img/chapter1/stage3.png")
      #s5s1b3.row.justify-content-center
        .col-11.col-md-9.col-lg-7.pause-t
          img.fit-h.img-fluid.mb-3(src="/assets/img/chapter1/stages-oval.png")
          p.text-center.large  
            span.bolder En las primeras dos etapas, 
            | se requiere una respuesta inmunológica para eliminar el virus y no permitir que la enfermedad progrese. Para que la respuesta inmunológica sea buena, la persona  huésped deberá tener buena salud y una genética con una respuesta inmune que  le ayude a recuperarse. 
      #s5s1b4.row.justify-content-center
        .col-12.col-md-9.col-lg-7.pause-t
          img.fit-h.img-fluid.mb-3(src="/assets/img/chapter1/stages2-oval.png")
        .col-11.col-md-9.col-lg-7.pause-b
          p.text-center.large Cuando la respuesta del sistema inmunológico falla, el virus se propagará y destruirá tejidos con alto nivel de receptores ACE2. El daño celular llevará a la fase de inflamación. La inflamación pulmonar  es la causa principal que lleva a trastornos respiratorios que amenazan la vida del paciente. 
        .col-12.col-md-9.col-lg-7.pause-b
          p.text-center.large Es por esto que al estar en la primera etapa de la enfermedad, el sistema inmune debe fortalecerse, mientras que en la segunda etapa es mejor suprimirlo para que baje la inflamación. 
        .fake-footer
</template>

<script>
export default {
  name: "Section5"
};
</script>
<style lang="scss" scoped>
#section5 {
  overflow: hidden;
  #s5s1 {
    padding-top: 30vh;
  }
  .fake-header {
    @include fakinH(1vh, 0%);
  }
  .fake-footer {
    @include fakinF(1vh, 0%);
  }
  .pause {
    margin: 16rem auto;
  }
  .pause-t {
    margin-top: 16rem;
  }
  .pause-b {
    margin-bottom: 16rem;
  }
  img {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  img.fit-h {
    max-height: 50vh;
  }
  .row p,
  .row h2 {
    margin-left: auto;
    margin-right: auto;
    max-width: 950px;
  }
  .bullet {
    position: absolute;
    right: 10%;
    top: -5%;
    border-radius: 50%;
    padding: 0.5rem;
    width: 2.5rem;
    height: 2.5rem;
  }
  .oval.top {
    top: 4%;
    left: 85%;
  }
  .oval.mid-1 {
    top: 10%;
    left: -85%;
    transform: rotate(10deg);
  }
  .oval.bottom {
    bottom: 0%;
    left: 79%;
    transform: rotate(62deg);
  }
}

@media (min-width: 768px) {
  #section5 {
    .oval.mid-1 {
      top: 10%;
      left: -55%;
      transform: rotate(10deg);
    }
    .oval.bottom {
      bottom: 1%;
      left: 85%;
      transform: rotate(62deg);
    }
  }
}

@media (min-width: 992px) {
  #section5 {
    .oval.top {
      left: -29%;
      transform: rotate(39deg);
    }
  }
}

@media (min-width: 1400px) {
  #section5 {
    .oval.top {
      left: -23%;
      transform: rotate(39deg);
    }
    .oval.bottom {
      bottom: 1%;
      left: 90%;
      transform: rotate(62deg);
    }
  }
}
</style>
